import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
export function HeadScripts() {
  return <Helmet data-id="element-92">
      {/* Meta Pixel Code */}
      <script data-id="element-93">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '3234410830058359');
          fbq('track', 'PageView');
        `}
      </script>
      <noscript data-id="element-94">
        {`
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=3234410830058359&ev=PageView&noscript=1"
          />
        `}
      </noscript>
      {/* End Meta Pixel Code */}
    </Helmet>;
}